import { render, staticRenderFns } from "./AddTeamNextBtn.vue?vue&type=template&id=0e12293d&scoped=true&lang=pug&"
var script = {}
import style0 from "./AddTeamNextBtn.vue?vue&type=style&index=0&id=0e12293d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e12293d",
  null
  
)

export default component.exports